import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
    	errorTypeEnum: {
    		openingTicketPurposeIsAlreadyAssociatedWithAnotherInstruction: 'Cette raison d\'ouverture de ticket est déjà associée à une autre instruction'
    	},
        newOpeningTicketInstruction: 'nouvelle instruction',
        openingTicketInstruction: 'instruction',
        openingTicketInstructions: 'instructions',
        openingTicketPurposes: 'raisons d\'ouverture de ticket'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/message/i18n.js